"use client";

import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactNode, useMemo } from "react";
import { defaultLogger } from "cy-logging";
import { notify } from "../components";
import { parseAsApiValidationError, throttle } from "cy-util";

export interface CyQueryClientProviderProps {
  children: ReactNode;
}

/**
 *
 */
export const CyQueryClientProvider = ({
  children,
}: CyQueryClientProviderProps) => {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            retry: (times: number, err: any) => {
              return ![422, 401, 403].includes(err.status) && times < 3;
            },
          },
        },
        queryCache: new QueryCache({
          onError: throttle((err) => {
            const validationError = parseAsApiValidationError(err);
            notify(
              "Error",
              validationError?.message || "An unexpected error occurred",
            );
            defaultLogger("ReactQuery").error(
              "An unexpected error occurred calling api",
              {},
              err,
            );
          }, 5000),
        }),
      }),
    [],
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
